// Copyright (c) 2022 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type FlagIconProps = SvgIconProps

// Note: this graphic is used for 'Status' and does not look like a flag.
const FlagIcon: React.FC<FlagIconProps> = (props) => {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g>
        <path d="M 4.160156 7.039062 C 4.160156 5.628906 5.308594 4.480469 6.71875 4.480469 L 6.71875 5.761719 L 7.191406 5.40625 L 9.28125 3.839844 L 6.71875 1.921875 L 6.71875 3.199219 C 4.601562 3.199219 2.878906 4.921875 2.878906 7.039062 C 2.878906 9.15625 4.601562 10.878906 6.71875 10.878906 L 8.640625 10.878906 L 8.640625 9.601562 L 6.71875 9.601562 C 5.308594 9.601562 4.160156 8.453125 4.160156 7.039062 Z M 4.160156 7.039062" />
        <path d="M 9.921875 3.199219 L 13.121094 3.199219 L 13.121094 4.480469 L 9.921875 4.480469 Z M 9.921875 3.199219" />
        <path d="M 9.921875 6.398438 L 13.121094 6.398438 L 13.121094 7.679688 L 9.921875 7.679688 Z M 9.921875 6.398438" />
        <path d="M 9.921875 9.601562 L 13.121094 9.601562 L 13.121094 10.878906 L 9.921875 10.878906 Z M 9.921875 9.601562" />
      </g>
    </SvgIcon>
  );
};

export default FlagIcon;